import RequestService from "@/services/request.service";
import { AppError } from "@/services/error.service";
import { clone } from "@/plugins/query";

const EventsService = {
  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Events/List%20Events
  getAll: async function (organizationId, filters) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/`;
      const params = filters;
      return await RequestService.get(path, params);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Events/Retrieve%20Event
  get: async function (organizationId, eventId) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/`;
      return await RequestService.get(path);
    } catch (error) {
      throw new AppError(error);
    }
  },

  _prepareEvent: function (data) {
    const payload = clone(data);
    payload.start_time = RequestService.formatDate(data.start_time);
    payload.end_time = RequestService.formatDate(data.end_time);
    return payload;
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Events/Create%20Event
  create: async function (organizationId, data) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/`;
      const payload = this._prepareEvent(data);
      return await RequestService.post(path, payload);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Events/Update%20Event
  update: async function (organizationId, data) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${data.id}/`;
      const payload = this._prepareEvent(data);
      return await RequestService.put(path, payload);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Events/v1_organizations_events_destroy
  delete: async function (organizationId, eventId) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/`;
      return await RequestService.delete(path);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Events/Get%20Event%20Stats
  stats: async function (organizationId, eventId) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/stats/`;
      return await RequestService.get(path);
    } catch (error) {
      throw new AppError(error);
    }
  },
};

export default EventsService;
